export default __webpack_public_path__ + "static/media/service2.4079e767.png";